module.exports = __webpack_public_path__ + "img/logo.cc9c434a.png";